import { render, staticRenderFns } from "./SubjectRsourcesDistributionChart.vue?vue&type=template&id=09020d68&scoped=true"
import script from "./SubjectRsourcesDistributionChart.vue?vue&type=script&lang=js"
export * from "./SubjectRsourcesDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./SubjectRsourcesDistributionChart.vue?vue&type=style&index=0&id=09020d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09020d68",
  null
  
)

export default component.exports